// extracted by mini-css-extract-plugin
export default {"container":"Metrics_container__wFF6E","metric":"Metrics_metric__LUctb","label":"Metrics_label__Edu9N","value":"Metrics_value__jvHxo"};